module.exports = __webpack_public_path__ + "media/images/lb/317-5a73801c1534e4eb802d2fc0d346bbfc.svg";